/**
 * Check Date
 * 
 * Überwacht Input Felder des Types `date` bei der Eingabe setzt automatisch einen Punkt zwischen
 * Tag, Monat und Jahr.
 * 
 * @version     1.0.0
 * @author      Erwin Müller Versandhaus GmbH
 */
(function(window, document, undefined) {
  var input = document.querySelectorAll("[input-type]");
  var type = "";

  document.addEventListener("DOMContentLoaded", function () {
    input = document.querySelectorAll("[input-type]");

    for (var i = 0; i < input.length; i++) {
      type = input[i].getAttribute("input-type");

      switch (type) {
        case "date":
          checkDate(input[i]);
          break;
      }
    }

    document.removeEventListener("DOMContentLoader", arguments.callee, false);
  });

  function checkDate (input) {
    var tmp, string;

    input.addEventListener("keydown", function (e) {

      if (this.value.length < 10 && ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105) || e.keyCode === 190)) {
        string = this.value;

        if ( e.keyCode === 190 ) {
          if (this.value.length === 0 || this.value.length === 3 || this.value.length === 6 || this.value.length > 6) {
            e.preventDefault();
            return false;
          }

          if ( string.length === 1 ) string = "0" + string;
          if ( string.length === 4 )  string = string.slice(0, 3) + "0" + string.slice(3);

          this.value = string;

          return
        }

        if ( string.length === 2 ) string = string + ".";
        if ( string.length === 5 ) string = string + ".";

        this.value = string;

        return;
      } else {
        switch (e.keyCode) {
          case 46: // delete
          case 8: // backspace
          case 9: // tab
          case 27: // esc
          case 13: // enter
          case 37: // left
          case 39: // right
            return;
        }

        e.preventDefault();
        return false;
      }
    });
  }
})(window, document);
